<template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader :loadingText="loadingText" />
  </div>
  <div v-else class="edit-category-view">
    <MainHeader :title="'Category Details'">
      <template #left>
        <font-awesome-icon
          @click="router.push({ name: 'Categories' })"
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
        />
      </template>
    </MainHeader>

    <div class="view ec-view">
      <div class="et-tabs">
        <button
          class="et-tab"
          :class="{ active: !editCategorySliderSelected }"
          @click="editCategorySliderSelected = false"
        >
          Info
        </button>
        <button
          class="et-tab"
          :class="{ active: editCategorySliderSelected }"
          @click="editCategorySliderSelected = true"
        >
          Edit
        </button>
      </div>

      <div v-if="!editCategorySliderSelected">
        <div class="ec-hero">
          <div
            class="ec-hero-icon"
            :style="{ background: store.editCategory.iconColor + '22' }"
          >
            <font-awesome-icon
              v-if="store.editCategory.icon"
              :icon="parseIconString(store.editCategory.icon)"
              :style="{ color: store.editCategory.iconColor }"
              style="font-size: 28px"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'tag']"
              style="font-size: 28px; color: #7f77dd"
            />
          </div>
          <h2 class="ec-hero-name">{{ store.editCategory.name }}</h2>
          <span v-if="store.editCategory.income" class="ec-income-badge"
            >Income</span
          >
        </div>

        <div class="wrapper-card ec-info-card">
          <div class="ud-section">
            <span class="section-label">Details</span>
            <div
              class="et-info-row"
              v-if="store.editCategory.hasOwnProperty('subcategoryID')"
            >
              <span class="et-info-label">Parent Category</span>
              <span class="et-info-value">{{
                selectedParentCategory?.name || 'N/A'
              }}</span>
            </div>
            <div class="et-info-row">
              <span class="et-info-label">Name</span>
              <span class="et-info-value">{{ store.editCategory.name }}</span>
            </div>
            <!-- <div class="et-info-row">
              <span class="et-info-label">Default Budget</span>
              <span class="et-info-value">
                {{
                  store.editCategory.defaultBudget
                    ? '$' + store.editCategory.defaultBudget
                    : '$0'
                }}
              </span>
            </div> -->
            <div class="et-info-row">
              <span class="et-info-label">Default Budget</span>
              <span class="et-info-value">
                <span
                  v-if="!store.editCategory.defaultBudget"
                  class="missing-budget-pill"
                  title="No default budget set"
                >
                  <font-awesome-icon :icon="['fas', 'triangle-exclamation']" />
                  Not set
                </span>
                <span v-else>${{ store.editCategory.defaultBudget }}</span>
              </span>
            </div>
            <div class="et-info-row">
              <span class="et-info-label">Color</span>
              <span class="et-info-value">
                <span
                  class="color-dot"
                  :style="{
                    background: store.editCategory.iconColor || '#ccc',
                  }"
                ></span>
              </span>
            </div>
            <div
              class="et-info-row"
              v-if="store.editCategory.hasOwnProperty('subcategories')"
            >
              <span class="et-info-label">Marked as Income</span>
              <span
                class="et-flag"
                :class="store.editCategory.income ? 'flag-income' : 'flag-off'"
              >
                {{ store.editCategory.income ? 'Yes' : 'No' }}
              </span>
            </div>
          </div>

          <div
            class="ud-section"
            v-if="store.editCategory.hasOwnProperty('subcategories')"
          >
            <span class="section-label">Subcategories</span>
            <div
              v-if="
                store.editCategory.subcategories &&
                store.editCategory.subcategories.length > 0
              "
            >
              <div
                v-for="item in store.editCategory.subcategories"
                :key="item"
                class="sub-info-row"
              >
                <div class="sub-info-icon">
                  <font-awesome-icon
                    :icon="parseIconString(item.icon)"
                    :style="{ color: item.iconColor }"
                    style="font-size: 13px"
                  />
                </div>
                <span class="sub-info-name">{{ item.name }}</span>
                <span
                  v-if="!item.defaultBudget"
                  class="missing-budget-pill sub-pill"
                  title="No default budget set"
                  style="margin-left: auto"
                >
                  <font-awesome-icon :icon="['fas', 'triangle-exclamation']" />
                </span>
              </div>
              <!-- <div
                v-for="item in store.editCategory.subcategories"
                :key="item"
                class="sub-info-row"
              >
                <div class="sub-info-icon">
                  <font-awesome-icon
                    :icon="parseIconString(item.icon)"
                    :style="{ color: item.iconColor }"
                    style="font-size: 13px"
                  />
                </div>
                <span class="sub-info-name">{{ item.name }}</span>
              </div> -->
            </div>
            <p v-else class="ec-empty-text">No subcategories</p>
          </div>

          <div class="ud-section">
            <span class="section-label">Auto-categorization rules</span>
            <div v-if="store.categoryRules && store.categoryRules.length > 0">
              <div
                v-for="item in store.categoryRules"
                :key="item"
                class="rule-pill"
              >
                <span class="rule-type">{{ item.type }}</span>
                <span class="rule-comparison">{{ item.comparison }}</span>
                <span class="rule-value">"{{ item.comparisonValue }}"</span>
              </div>
            </div>
            <p v-else class="ec-empty-text">No rules set</p>
          </div>
        </div>

        <button
          class="delete-btn mt-3 w-100"
          @click.prevent="deleteCategoryWarning"
        >
          Delete Category
        </button>
      </div>

      <div v-else>
        <form @submit.prevent="updateCategory" class="add-category-form">
          <fieldset>
            <div class="ud-section">
              <span class="section-label">Details</span>

              <div
                class="ud-field"
                v-if="store.editCategory.hasOwnProperty('subcategoryID')"
              >
                <label class="ud-label" for="parentCategory">
                  Parent Category <span class="ud-asterisk">*</span>
                </label>
                <select
                  v-model="selectedEditParentCategory"
                  class="ud-input ud-select form-select"
                  required
                >
                  <option
                    v-for="parentCategory in store.categories"
                    :key="parentCategory"
                    :value="parentCategory"
                    :selected="parentCategory"
                  >
                    {{ parentCategory.name }}
                  </option>
                </select>
              </div>

              <div class="ud-field mt">
                <label class="ud-label" for="categoryName">
                  Category Name <span class="ud-asterisk">*</span>
                </label>
                <input
                  type="text"
                  class="ud-input"
                  id="categoryName"
                  v-model="categoryName"
                  required
                />
              </div>

              <div class="ud-field mt">
                <label class="ud-label" for="defaultBudget">
                  Default Budget
                  <span
                    v-if="!defaultBudget || defaultBudget == 0"
                    class="missing-budget-pill"
                    title="No default budget set"
                    style="margin-left: 6px"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'triangle-exclamation']"
                    />
                    Not set
                  </span>
                </label>
                <input
                  type="number"
                  class="ud-input"
                  id="defaultBudget"
                  v-model="defaultBudget"
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                />
              </div>
              <!-- <div class="ud-field mt">
                <label class="ud-label" for="defaultBudget"
                  >Default Budget</label
                >
                <input
                  type="number"
                  class="ud-input"
                  id="defaultBudget"
                  v-model="defaultBudget"
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                />
              </div> -->
            </div>

            <div class="ud-section">
              <span class="section-label">Appearance</span>

              <div class="ud-field">
                <label class="ud-label" for="selectIcon">Category Icon</label>
                <IconSearch
                  button-text="Choose Icon"
                  styleClass="form-dropdown"
                  :options="
                    store.editCategory.icon !== null
                      ? store.editCategory.icon
                      : []
                  "
                  @optionSelected="updateSelectedIcon($event)"
                />
              </div>

              <div class="ud-field mt">
                <label class="ud-label" for="categoryColor"
                  >Category Color</label
                >
                <ColorSelection
                  button-text="Choose Color"
                  styleClass="form-dropdown"
                  :options="
                    store.editCategory.iconColor !== null
                      ? store.editCategory.iconColor
                      : []
                  "
                  @optionSelected="updateSelectedIconColor($event)"
                />
              </div>
            </div>

            <div
              class="ud-section"
              v-if="
                Object.prototype.hasOwnProperty.call(
                  store.editCategory,
                  'subcategories'
                )
              "
            >
              <span class="section-label">Subcategories</span>
              <div class="expandable-section">
                <div
                  class="expandable-header"
                  @click="showEditSubcategories = !showEditSubcategories"
                >
                  <span class="ud-label">Edit Subcategories</span>
                  <font-awesome-icon
                    :icon="['fas', 'caret-down']"
                    class="expand-caret"
                    :class="{ expanded: showEditSubcategories }"
                  />
                </div>
                <transition name="sub-slide">
                  <div v-if="showEditSubcategories" class="expandable-body">
                    <button
                      aria-label="Add Subcategory"
                      role="button"
                      class="outline-button w-100 mb-1"
                      type="button"
                      @click="addSubcategory"
                    >
                      + Add Subcategory
                    </button>
                    <div
                      v-for="subcategory in store.editCategory.subcategories"
                      :key="subcategory"
                      class="sub-edit-row"
                    >
                      <div class="sub-edit-icon">
                        <font-awesome-icon
                          :icon="parseIconString(subcategory.icon)"
                          :style="{ color: subcategory.iconColor }"
                          style="font-size: 13px"
                        />
                      </div>
                      <span class="sub-edit-name">{{ subcategory.name }}</span>
                      <font-awesome-icon
                        :icon="['fas', 'trash']"
                        class="sub-delete-icon pointer"
                        @click="deleteSubcategory(subcategory)"
                      />
                    </div>
                  </div>
                </transition>
              </div>
            </div>

            <div class="ud-section">
              <span class="section-label">Auto-categorization rules</span>
              <div class="expandable-section">
                <div
                  class="expandable-header"
                  @click="showAutoCategorization = !showAutoCategorization"
                >
                  <span class="ud-label">Apply Rules</span>
                  <font-awesome-icon
                    :icon="['fas', 'caret-down']"
                    class="expand-caret"
                    :class="{ expanded: showAutoCategorization }"
                  />
                </div>
                <transition name="sub-slide">
                  <div v-if="showAutoCategorization" class="expandable-body">
                    <button
                      aria-label="Add Rule"
                      role="button"
                      class="outline-button w-100 mb-1"
                      type="button"
                      @click="createNewRule"
                    >
                      + Add Rule
                    </button>
                    <div v-for="(rule, index) in ruleItems" :key="rule">
                      <Rule
                        :currentRule="ruleItems[index].rule"
                        @addRule="createNewRule"
                        @updateRule="(rule) => updateRulesList(index, rule)"
                        @deleteRule="(rule) => deleteFromRulesList(index, rule)"
                      />
                    </div>
                  </div>
                </transition>
              </div>
            </div>

            <div
              class="ud-section"
              v-if="store.editCategory.hasOwnProperty('subcategories')"
            >
              <span class="section-label">Settings</span>
              <div class="toggle-row">
                <span class="ud-label">Mark as Income</span>
                <Toggle
                  id="isIncome"
                  :toggleActive="incomeCategory"
                  @toggleSelected="toggleIncome($event)"
                />
              </div>
            </div>

            <button
              aria-label="Update Category"
              role="button"
              type="submit"
              class="ud-submit"
              data-pt-name="update category"
            >
              Update Category
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  </div>

  <Modal ref="modalRef">
    <template #header>
      <h2>Confirm deletion</h2>
    </template>
    <template #body>
      <p>
        You are about to delete <strong>{{ store.editCategory.name }}</strong
        >. Any transactions assigned to this category will become uncategorized.
      </p>
      <p class="mt-1">
        Would you like to reassign those transactions to a different category
        first?
      </p>
      <div class="mb-2 mt-1">
        <select
          class="ud-input ud-select form-select mb-1"
          v-model="parentCategoryDeleteCategory"
          @change="selectedParentCategoryDeleteCategory"
        >
          <option value="" selected disabled>Select a category</option>
          <option
            v-for="parentCategory in store.categories"
            :key="parentCategory.categoryID"
            :value="parentCategory"
          >
            {{ parentCategory.name }}
          </option>
        </select>
        <select
          v-if="
            parentCategoryDeleteCategory &&
            parentCategoryDeleteCategory.subcategories
          "
          class="ud-input ud-select form-select"
          v-model="selectedSubcategoryDeleteCategory"
        >
          <option value="" selected disabled>Select a subcategory</option>
          <option
            v-for="subcategory in parentCategoryDeleteCategory.subcategories"
            :key="subcategory.categoryID"
            :value="subcategory"
          >
            {{ subcategory.name }}
          </option>
        </select>
      </div>
    </template>
    <template #footer>
      <div class="modal-footer-buttons">
        <button class="teal-outline-button" @click="closeRecategorizeModal">
          Leave uncategorized
        </button>
        <button
          class="teal-button"
          :disabled="!parentCategoryDeleteCategory"
          @click="closeRecategorizeModal"
        >
          Apply category
        </button>
      </div>
    </template>
  </Modal>

  <Modal ref="confirmBudgetEditModal">
    <template #header>
      <h2>Update default budget</h2>
    </template>
    <template #body>
      <p>
        You are updating the default budget for
        <strong>{{ categoryName }}</strong> to
        <strong>${{ defaultBudget }}</strong
        >.
      </p>
      <div class="mt-1 mb-1">
        <label class="filter-check-label">
          <input
            type="checkbox"
            v-model="updateCurrentMonth"
            value="currentMonthUpdate"
          />
          Apply to my current month's budget
        </label>
      </div>
      <div class="mb-2">
        <label class="filter-check-label">
          <input
            type="checkbox"
            v-model="updateFutureMonthsWithCustomBudgets"
            value="currentMonthUpdate"
          />
          Also update future months where I manually customized the budget
        </label>
      </div>
    </template>
    <template #footer>
      <div class="modal-footer-buttons">
        <button class="teal-outline-button" @click="closeUpdateBudgetModal">
          Cancel
        </button>
        <button class="teal-button" @click="updateCategoryBudget">
          Update Budget
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useMyStore } from '../store';
import { useRouter } from 'vue-router';
import {
  ref,
  reactive,
  watch,
  onUnmounted,
  onBeforeMount,
  onMounted,
} from 'vue';
import MainHeader from '../components/View-Header.vue';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import ColorSelection from '../components/Color-Selection.vue';
import Rule from '../components/Categorization-Rule.vue';
import { Edit_Category_Types } from '../utils/constants.js';
import Toggle from '../components/Toggle.vue';
import SkeletonLoader from '../components/SkeletonLoader.vue';
import IconSearch from '../components/Icon-Selector.vue';
import Modal from '../components/Main-Modal.vue';

export default {
  components: {
    MainHeader,
    ColorSelection,
    Rule,
    Toggle,
    SkeletonLoader,
    IconSearch,
    Modal,
  },
  setup() {
    const store = useMyStore();
    const router = useRouter();
    const searchTerm = ref('');
    const searchResults = reactive({});
    let showAutoCategorization = ref(false);
    let showEditSubcategories = ref(false);
    const selectedRule = ref(null);
    let ruleItems = ref([{ id: 1, rule: {} }]);
    let editCategorySliderSelected = ref(false);
    let selectedParentCategory = ref(null);
    const selectedEditParentCategory = ref(
      store.categories.find(
        (x) => x.categoryID === store.editCategory.categoryID
      )
    );
    const categoryName = ref(store.editCategory.name);
    const accountIcon = ref(store.editCategory.icon);
    let selectedCategoryIcon = ref();
    let selectedCategoryIconColor = ref();
    const defaultBudget = ref(store.editCategory.defaultBudget);
    let incomeCategory = ref(store.editCategory.income || false);
    let loading = ref(true);
    let loadingText = ref('Loading...');
    const modalRef = ref(null);
    let parentCategoryDeleteCategory = ref('');
    let selectedSubcategoryDeleteCategory = ref('');
    let updateCurrentMonth = ref(false);
    let updateFutureMonthsWithCustomBudgets = ref(false);
    const confirmBudgetEditModal = ref(null);

    function searchIcons() {
      if (searchTerm.value.length < 3) return;
      const results = findIconDefinition({
        prefix: '',
        iconName: searchTerm.value,
      });
      searchResults.value = results;
    }

    ruleItems = ref(store.categoryRules);

    const createNewRule = () => {
      const newRuleId = ruleItems.value.length + 1;
      ruleItems.value.push({ id: newRuleId, rule: {} });
    };

    const updateRulesList = (index, rule) => {
      ruleItems.value[index].rule = rule;
    };

    const deleteFromRulesList = (index) => {
      ruleItems.value.splice(index, 1);
    };

    const sliderOptionUpdated = (selection) => {
      if (selection === Edit_Category_Types.edit) {
        showAutoCategorization.value =
          store.categoryRules && store.categoryRules.length > 0;
        editCategorySliderSelected.value = true;
      } else {
        editCategorySliderSelected.value = false;
      }
    };

    const parseIconString = (iconString) => {
      if (iconString) {
        const [category, icon] = iconString.split(' ');
        return [category, icon];
      }
      return null;
    };

    const addSubcategory = () => {
      store.updateAddSubcategoryToEditCategory(true);
      let id = selectedEditParentCategory.value.categoryID;
      router.push({ name: 'AddCategory', query: { id } });
    };

    const deleteSubcategory = (subcategory) => {
      const index = store.editCategory.subcategories.indexOf(subcategory);
      if (index !== -1) store.editCategory.subcategories.splice(index, 1);
    };

    const updateSelectedIcon = (selectedIcon) => {
      selectedCategoryIcon.value = selectedIcon;
    };
    const updateSelectedIconColor = (selectedColor) => {
      selectedCategoryIconColor.value = selectedColor;
    };
    const toggleIncome = (event) => {
      incomeCategory.value = event;
    };

    watch(
      () => store.categoryRules,
      (newRules) => {
        ruleItems.value = newRules.map((rule, index) => ({
          id: index + 1,
          rule,
        }));
      }
    );

    const updateCategoryBudget = async () => {
      loadingText.value = 'Updating Category...';
      loading.value = true;
      try {
        let rules;
        if (store.editCategoryIsSubcategory === true) {
          if (
            categoryName.value !== null &&
            categoryName.value.length > 0 &&
            selectedEditParentCategory.value !== null
          ) {
            let newSubCategory = {
              SubcategoryID: store.editCategory.subcategoryID,
              CategoryID: selectedEditParentCategory.value.categoryID,
              Name: categoryName.value,
              Icon: selectedCategoryIcon.value,
              IconColor: selectedCategoryIconColor.value,
              DefaultBudget: defaultBudget.value,
              UpdateCurrentMonthBudget: updateCurrentMonth.value,
              UpdateFutureMonthsWithCustomBudgets:
                updateFutureMonthsWithCustomBudgets.value,
            };
            await store.saveSubcategory(newSubCategory).then(() => {
              loading.value = false;
            });
            rules = {
              CategoryID: store.editCategory.categoryID,
              SubcategoryID: store.editCategory.subcategoryID,
              CategoryRules: ruleItems.value.map((ruleItem) => ({
                Type: ruleItem.rule.type,
                Comparison: ruleItem.rule.comparison,
                ComparisonValue: ruleItem.rule.comparisonValue,
              })),
            };
            await store.saveCategoryRules(rules).then(() => {
              loading.value = false;
              router.push({ name: 'Categories' });
            });
          }
        } else {
          let categoryDetails = {
            CategoryID: store.editCategory.categoryID,
            Name: categoryName.value,
            Icon: selectedCategoryIcon.value.toString(),
            IconColor: selectedCategoryIconColor.value.toString(),
            DefaultBudget: defaultBudget.value,
            Subcategories: store.editCategory.subcategories
              ? store.editCategory.subcategories
              : [],
            Rules: ruleItems.value,
            Income: incomeCategory.value,
            UpdateCurrentMonthBudget: updateCurrentMonth.value,
            UpdateFutureMonthsWithCustomBudgets:
              updateFutureMonthsWithCustomBudgets.value,
          };
          rules = {
            CategoryID: store.editCategory.categoryID,
            SubcategoryID: null,
            CategoryRules: ruleItems.value.map((ruleItem) => ({
              Type: ruleItem.rule.type,
              Comparison: ruleItem.rule.comparison,
              ComparisonValue: ruleItem.rule.comparisonValue,
            })),
          };
          await store.saveCategory(categoryDetails);
          await store.saveCategoryRules(rules).then(() => {
            loading.value = false;
            router.push({ name: 'Categories' });
          });
        }
      } catch (error) {
        loading.value = false;
        console.error('An error occurred:', error);
      }
    };

    const updateCategory = async () => {
      if (defaultBudget.value !== store.editCategory.defaultBudget) {
        confirmBudgetEditModal.value?.openModal();
      } else {
        updateCategoryBudget();
      }
    };

    const deleteCategoryWarning = () => {
      modalRef.value?.openModal();
    };

    const deleteCategory = async () => {
      loadingText.value = 'Deleting Category...';
      loading.value = true;
      try {
        if (
          !Object.prototype.hasOwnProperty.call(
            store.editCategory,
            'subcategoryID'
          )
        ) {
          let categoryDetails = {
            CategoryID: store.editCategory.categoryID,
            Name: store.editCategory.name,
            Subcategories:
              store.editCategory.subcategories === null
                ? []
                : store.editCategory.subcategories,
            Rules: ruleItems.value,
            NewCategoryID: parentCategoryDeleteCategory.value
              ? parentCategoryDeleteCategory.value.categoryID
              : null,
            newSubCategoryID: selectedSubcategoryDeleteCategory.value
              ? selectedSubcategoryDeleteCategory.value.subcategoryID
              : null,
          };
          await store.deleteCategory(categoryDetails).then(() => {
            loading.value = false;
            router.push({ name: 'Categories' });
          });
        } else {
          let subcategoryDetails = {
            SubcategoryID: store.editCategory.subcategoryID,
            CategoryID: store.editCategory.categoryID,
            Name: store.editCategory.name,
            Subcategories:
              store.editCategory.subcategories === null
                ? []
                : store.editCategory.subcategories,
            Rules: ruleItems.value,
            NewCategoryID: parentCategoryDeleteCategory.value
              ? parentCategoryDeleteCategory.value.categoryID
              : null,
            newSubCategoryID: selectedSubcategoryDeleteCategory.value
              ? selectedSubcategoryDeleteCategory.value.subcategoryID
              : null,
          };
          await store.deleteSubcategory(subcategoryDetails).then(() => {
            loading.value = false;
            router.push({ name: 'Categories' });
          });
        }
        store.getAllCategories();
        router.push({ name: 'Categories' });
      } catch (error) {
        loading.value = false;
        console.error('An error occurred:', error);
      }
    };

    const closeUpdateBudgetModal = () => {
      confirmBudgetEditModal.value?.closeModal();
    };

    const closeRecategorizeModal = () => {
      modalRef.value?.closeModal();
      deleteCategory();
    };

    const selectedParentCategoryDeleteCategory = () => {
      selectedSubcategoryDeleteCategory.value = null;
    };

    onBeforeMount(() => {
      if (
        Object.prototype.hasOwnProperty.call(
          store.editCategory,
          'subcategoryID'
        )
      ) {
        selectedParentCategory.value = store.categories.find(
          (category) => category.categoryID === store.editCategory.categoryID
        );
      }
    });

    onMounted(async () => {
      loading.value = true;
      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) mainElement.scrollTo(0, 0);
      }, 100);

      if (!store.editCategory || Object.keys(store.editCategory).length === 0) {
        router.push({ name: 'Categories' });
      }

      updateSelectedIcon(store.editCategory.icon);
      updateSelectedIconColor(store.editCategory.iconColor);
      showEditSubcategories.value = store.editCategory.subcategories
        ? store.editCategory.subcategories.length > 0
        : false;
      incomeCategory.value = store.editCategory.income || false;
      ruleItems.value = store.categoryRules
        ? store.categoryRules.map((rule, index) => ({ id: index + 1, rule }))
        : [];

      loading.value = false;
    });

    onUnmounted(() => {
      if (!store.addSubcategoryToEditCategory) store.updateEditCategory({});
    });

    return {
      store,
      router,
      searchIcons,
      searchTerm,
      searchResults,
      showAutoCategorization,
      showEditSubcategories,
      selectedRule,
      createNewRule,
      ruleItems,
      updateRulesList,
      deleteFromRulesList,
      sliderOptionUpdated,
      editCategorySliderSelected,
      addSubcategory,
      updateCategory,
      deleteSubcategory,
      parseIconString,
      deleteCategory,
      selectedParentCategory,
      selectedEditParentCategory,
      categoryName,
      accountIcon,
      updateSelectedIconColor,
      updateSelectedIcon,
      defaultBudget,
      toggleIncome,
      loading,
      loadingText,
      modalRef,
      parentCategoryDeleteCategory,
      selectedParentCategoryDeleteCategory,
      selectedSubcategoryDeleteCategory,
      deleteCategoryWarning,
      incomeCategory,
      updateCurrentMonth,
      updateFutureMonthsWithCustomBudgets,
      confirmBudgetEditModal,
      updateCategoryBudget,
      closeRecategorizeModal,
      closeUpdateBudgetModal,
    };
  },
};
</script>

<style scoped>
.ec-view {
  max-width: 480px;
  margin: 0 auto;
}

.et-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 1.5rem;
  background: #f0f0f4;
  border-radius: var(--radius-pill);
  padding: 4px;
}
.dark-theme .et-tabs {
  background: #1a2535;
}

.et-tab {
  border: none;
  border-radius: var(--radius-pill);
  padding: 0.6rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  color: #888;
  transition: all 0.2s ease;
}
.et-tab.active {
  background: linear-gradient(135deg, #7f77dd, #5dcaa5);
  color: white;
  box-shadow: 0 4px 12px rgba(127, 119, 221, 0.3);
}

.ec-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0 1.25rem;
  animation: slideUp 0.4s ease both;
}
.ec-hero-icon {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
  animation: popIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}
.ec-hero-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: #004751;
  margin: 0 0 0.4rem;
  letter-spacing: -0.02em;
  text-align: center;
}
.dark-theme .ec-hero-name {
  color: white;
}
.ec-income-badge {
  font-size: 11px;
  font-weight: 700;
  background: #e1f5ee;
  color: #0f6e56;
  padding: 3px 10px;
  border-radius: 20px;
  letter-spacing: 0.03em;
}

.ec-info-card {
  animation: cardSlideUp 0.4s cubic-bezier(0.34, 1.2, 0.64, 1) both;
}

.et-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.dark-theme .et-info-row {
  border-bottom-color: #2a3a4e;
}
.et-info-row:last-child {
  border-bottom: none;
}

.et-info-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #888;
}
.et-info-value {
  font-size: 0.82rem;
  font-weight: 500;
  color: #213547;
  text-align: right;
}
.dark-theme .et-info-value {
  color: #d4d2d2;
}

.color-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.et-flag {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
}
.flag-income {
  background: #e1f5ee;
  color: #0f6e56;
}

.sub-info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.55rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.dark-theme .sub-info-row {
  border-bottom-color: #2a3a4e;
}
.sub-info-row:last-child {
  border-bottom: none;
}
.sub-info-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #f4f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dark-theme .sub-info-icon {
  background: #1a2535;
}
.sub-info-name {
  font-size: 0.82rem;
  font-weight: 500;
  color: #515a65;
}
.dark-theme .sub-info-name {
  color: #d4d2d2;
}

.rule-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.5rem 0.75rem;
  background: #eeedfe;
  border-radius: 10px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}
.dark-theme .rule-pill {
  background: #1e1a40;
}
.rule-type {
  font-size: 0.72rem;
  font-weight: 700;
  color: #7f77dd;
}
.rule-comparison {
  font-size: 0.72rem;
  color: #888;
}
.rule-value {
  font-size: 0.72rem;
  font-weight: 600;
  color: #3c3489;
}
.dark-theme .rule-value {
  color: #afa9ec;
}

.ec-empty-text {
  font-size: 0.78rem;
  color: #aaa;
  margin: 0.5rem 0 0;
  font-style: italic;
}

.expandable-section {
  border: 1.5px solid #e7e7e7;
  border-radius: 12px;
  overflow: hidden;
}
.dark-theme .expandable-section {
  border-color: #2a3a4e;
}

.expandable-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background var(--transition-fast);
}
.expandable-header:hover {
  background: #fafafa;
}
.dark-theme .expandable-header:hover {
  background: #1a2535;
}

.expand-caret {
  color: #888;
  transition: transform 0.25s ease;
}
.expand-caret.expanded {
  transform: rotate(180deg);
  color: var(--color-accent-purple);
}

.expandable-body {
  border-top: 1.5px solid #f0f0f0;
  padding: 0.75rem 1rem;
  background: #fafafa;
}
.dark-theme .expandable-body {
  border-top-color: #2a3a4e;
  background: #1a2535;
}

.sub-edit-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.55rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.dark-theme .sub-edit-row {
  border-bottom-color: #2a3a4e;
}
.sub-edit-row:last-child {
  border-bottom: none;
}
.sub-edit-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
}
.sub-edit-name {
  flex: 1;
  font-size: 0.82rem;
  font-weight: 500;
  color: #515a65;
}
.dark-theme .sub-edit-name {
  color: #d4d2d2;
}
.sub-delete-icon {
  font-size: 0.78rem;
  color: #d85a30;
  transition: color var(--transition-fast);
}
.sub-delete-icon:hover {
  color: #993c1d;
}

.delete-btn {
  border: none;
  border-radius: 50px;
  padding: 0.75rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  background: white;
  color: #d85a30;
  border: 2px solid #d85a30;
  cursor: pointer;
  transition:
    background 0.15s,
    transform 0.15s;
}
.delete-btn:hover {
  background: #faece7;
  transform: translateY(-1px);
}
.delete-btn:active {
  transform: scale(0.97);
}
.dark-theme .delete-btn {
  background: transparent;
  color: #f09595;
  border-color: #f09595;
}

.sub-slide-enter-from,
.sub-slide-leave-to {
  transform: translateY(-4px);
}
.sub-slide-enter-to,
.sub-slide-leave-from {
  opacity: 1;
  max-height: 600px;
  transform: translateY(0);
}

.filter-check-label {
  font-size: 0.82rem;
  font-weight: 500;
  color: #555;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.dark-theme .filter-check-label {
  color: #aab;
}

.icon-wrapper svg {
  display: block;
  position: relative;
  font-size: 14px;
  line-height: 30px;
}
.dark-theme .icon-wrapper:before,
.dark-theme .sub-icon-wrapper:before {
  background: #212e3e;
}

.missing-budget-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 600;
  color: #b8895f;
  background: rgba(216, 156, 110, 0.12);
  padding: 0 7px;
  height: 18px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  flex-shrink: 0;
  vertical-align: middle;
}
.missing-budget-pill svg {
  font-size: 8px;
}
.missing-budget-pill.sub-pill {
  padding: 0 5px;
  height: 16px;
}
.missing-budget-pill.sub-pill svg {
  font-size: 7px;
}
.dark-theme .missing-budget-pill {
  background: rgba(216, 156, 110, 0.18);
  color: #d8a87e;
}
</style>

<!-- <template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader :loadingText="loadingText" />
  </div>
  <div v-else>
    <MainHeader :title="'Category Details'">
      <template #left>
        <font-awesome-icon
          @click="router.push({ name: 'Categories' })"
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
        />
      </template>
    </MainHeader>
    <div class="view">
      <div>
        <Slider
          :options="sliderOptions"
          @sliderSelection="sliderOptionUpdated($event)"
        ></Slider>
      </div>
      <div class="add-category-form" v-if="editCategorySliderSelected">
        <div class="text-center pt-4 pb-4">
          <font-awesome-icon
            :icon="['fas', 'folder-open']"
            class="view-icon info-icon"
          />
        </div>
        <form @submit.prevent="updateCategory">
          <fieldset>
            <div
              v-if="store.editCategory.hasOwnProperty('subcategoryID')"
              class="mt-1"
            >
              <label for="accountType" class="small-grey-text"
                >Parent Category *</label
              >
              <p id="accountType">
                <select
                  v-model="selectedEditParentCategory"
                  class="form-select grey-form-select"
                  required
                >
                  <option
                    v-for="parentCategory in store.categories"
                    :key="parentCategory"
                    :value="parentCategory"
                    :selected="parentCategory"
                  >
                    {{ parentCategory.name }}
                  </option>
                </select>
              </p>
            </div>
            <div class="mt-1">
              <label for="categoryName" class="small-grey-text"
                >Category Name *</label
              >
              <div id="categoryName">
                <input
                  type="text"
                  class="input"
                  v-model="categoryName"
                  required
                />
              </div>
            </div>
            <div class="mt-1">
              <label for="selectIcon" class="small-grey-text"
                >Category Icon</label
              >
              <div id="selectIcon">
                <IconSearch
                  button-text="Choose Icon"
                  styleClass="form-dropdown"
                  :options="
                    store.editCategory.icon !== null
                      ? store.editCategory.icon
                      : []
                  "
                  @optionSelected="updateSelectedIcon($event)"
                />
              </div>
            </div>
            <div class="mt-1">
              <label for="categoryColor" class="small-grey-text"
                >Category Color</label
              >
              <div id="categoryColor">
                <ColorSelection
                  button-text="Choose Color"
                  styleClass="form-dropdown"
                  :options="
                    store.editCategory.iconColor !== null
                      ? store.editCategory.iconColor
                      : []
                  "
                  @optionSelected="updateSelectedIconColor($event)"
                >
                </ColorSelection>
              </div>
            </div>
            <div class="mt-1">
              <label for="defaultBudget" class="small-grey-text"
                >Default Budget</label
              >
              <div id="defaultBudget">
                <input 
                  type="number" 
                  class="input" 
                  v-model="defaultBudget"
                  step="0.01"
                  min="0"
                />
              </div>
            </div>
            <div
              class="mt-1"
              v-if="
                Object.prototype.hasOwnProperty.call(
                  store.editCategory,
                  'subcategories'
                )
              "
            >
              <label for="subcategories" class="small-grey-text"
                >Subcategories</label
              >
              <div class="subcategorization-card edit-subcategorization-card">
                <div
                  @click="showEditSubcategories = !showEditSubcategories"
                  class="w-100 flex align-center justify-between dropdown-padding"
                >
                  <div>Edit Subcategories</div>
                  <font-awesome-icon
                    :icon="['fas', 'caret-down']"
                    class="arrow"
                    :class="{ active: showEditSubcategories }"
                  />
                </div>
                <div
                  v-if="showEditSubcategories"
                  class="subcategory-list-wrapper edit-subcategory-list-wrapper"
                >
                  <button
                    aria-label="Add Subcategory"
                    role="button"
                    class="grey-button w-100"
                    type="button"
                    @click="addSubcategory"
                  >
                    Add Subcategory
                    <font-awesome-icon :icon="['fas', 'circle-plus']" />
                  </button>
                  <div
                    v-for="subcategory in store.editCategory.subcategories"
                    :key="subcategory"
                    class="flex align-center mt-half subcategory-item"
                  >
                    <div
                      class="icon-wrapper d-flex justify-center align-center"
                    >
                      <font-awesome-icon
                        :icon="parseIconString(subcategory.icon)"
                        :style="{ color: subcategory.iconColor }"
                        class="subcategory-icon"
                      />
                    </div>
                    <div class="ms-1 subcategory-label">
                      {{ subcategory.name }}
                      <font-awesome-icon
                        :icon="['fas', 'trash']"
                        class="icon pointer"
                        @click="deleteSubcategory(subcategory)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-1">
              <label for="autocategorization" class="small-grey-text"
                >Auto Categorization</label
              >
              <div class="subcategorization-card edit-subcategorization-card">
                <div
                  @click="showAutoCategorization = !showAutoCategorization"
                  class="w-100 flex align-center justify-between dropdown-padding"
                >
                  <div>Apply Rules</div>
                  <font-awesome-icon
                    :icon="['fas', 'caret-down']"
                    class="arrow"
                    :class="{ active: showAutoCategorization }"
                  />
                </div>
                <div
                  v-if="showAutoCategorization"
                  class="subcategory-list-wrapper edit-subcategory-list-wrapper"
                >
                  <button
                    aria-label="Add Rule"
                    role="button"
                    class="grey-button w-100"
                    type="button"
                    @click="createNewRule"
                  >
                    Add Rule
                    <font-awesome-icon :icon="['fas', 'circle-plus']" />
                  </button>
                  <div v-for="(rule, index) in ruleItems" :key="rule">
                    <Rule
                      :currentRule="ruleItems[index].rule"
                      @addRule="createNewRule"
                      @updateRule="(rule) => updateRulesList(index, rule)"
                      @deleteRule="(rule) => deleteFromRulesList(index, rule)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="store.editCategory.hasOwnProperty('subcategories')"
              class="mt-1"
            >
              <label for="isIncome" class="small-grey-text"
                >Mark as Income</label
              >
              <Toggle
                id="isIncome"
                :toggleActive="incomeCategory"
                @toggleSelected="toggleIncome($event)"
              />
            </div>
            <div class="mt-4">
              <button
                aria-label="Update Category"
                role="button"
                type="submit"
                class="blue-button mt-1 w-100"
                data-pt-name="update category"
                data-pt-property-category="update category"
              >
                Update Category
              </button>
            </div>
          </fieldset>
        </form>
      </div>

      <div v-else>
        <div class="text-center pt-4 pb-4">
          <font-awesome-icon
            :icon="['fas', 'folder']"
            class="view-icon info-icon"
          />
        </div>
        <div class="cat-info-card">
          <form>
            <fieldset>
              <div
                class="mt-1"
                v-if="store.editCategory.hasOwnProperty('subcategoryID')"
              >
                <label class="small-grey-text">Parent Category</label>
                <div>{{ selectedParentCategory.name }}</div>
              </div>
              <div class="mt-1">
                <label class="small-grey-text">Category Name</label>
                <div>
                  {{ store.editCategory.name }}
                </div>
              </div>
              <div class="mt-1">
                <label class="small-grey-text">Category Icon</label>
              </div>
              <div>
                <div v-if="store.editCategory.icon">
                  <font-awesome-icon
                    :icon="parseIconString(store.editCategory.icon)"
                  />
                </div>
                <div v-else>No icon selected</div>
              </div>
              <div class="mt-1">
                <label class="small-grey-text">Category Color</label>
              </div>
              <div>
                <div v-if="store.editCategory.iconColor">
                  <div
                    class="category-color"
                    :style="{ background: store.editCategory.iconColor }"
                  ></div>
                </div>
                <div v-else>No color selected</div>
              </div>
              <div class="mt-1">
                <label class="small-grey-text">Default Budget</label>
              </div>
              <div>
                {{
                  store.editCategory.defaultBudget
                    ? store.editCategory.defaultBudget
                    : 0
                }}
              </div>
              <div
                class="mt-1"
                v-if="store.editCategory.hasOwnProperty('subcategories')"
              >
                <label class="small-grey-text">Subcategories</label>
                <div class="subcategorization-card">
                  <div class="subcategory-list-wrapper">
                    <div
                      v-if="
                        store.editCategory.subcategories &&
                        store.editCategory.subcategories.length > 0
                      "
                    >
                      <div
                        v-for="item in store.editCategory.subcategories"
                        :key="item"
                        class="flex align-center mb-1 subcategory-item"
                      >
                        <div
                          class="icon-wrapper d-flex justify-center align-center"
                        >
                          <font-awesome-icon
                            :icon="parseIconString(item.icon)"
                            :style="{ color: item.iconColor }"
                            class="search-icon pointer"
                          />
                        </div>
                        <div class="ms-1">{{ item.name }}</div>
                      </div>
                    </div>
                    <div v-else>No subcategories</div>
                  </div>
                </div>
              </div>
              <div class="mt-1">
                <label class="small-grey-text">Autocategorization Rules</label>
                <div
                  v-if="store.categoryRules && store.categoryRules.length > 0"
                >
                  <div v-for="item in store.categoryRules" :key="item">
                    <div class="flex mb-1 auto-rules">
                      <div>{{ item.type }}</div>
                      <div class="ms-1">{{ item.comparison }}</div>
                      <div class="ms-1">{{ item.comparisonValue }}</div>
                    </div>
                  </div>
                </div>
                <div v-else>No autocategorization rules</div>
              </div>
              <div
                v-if="store.editCategory.hasOwnProperty('subcategories')"
                class="mt-1"
              >
                <label class="small-grey">Marked As Income</label>
                <div>
                  <div>
                    <font-awesome-icon
                      :icon="
                        store.editCategory.income === true
                          ? ['fas', 'circle-check']
                          : ['fas', 'circle-xmark']
                      "
                      class="teal"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <button
          class="red-button mt-4 w-100"
          @click.prevent="deleteCategoryWarning"
        >
          Delete Category
        </button>
      </div>
    </div>
  </div>
  <Modal ref="modalRef">
    <template #header>
      <h2>Confirm Category Deletion</h2>
    </template>
    <template #body>
      <p>
        You are about to delete the category "<strong>{{
          store.editCategory.name
        }}</strong
        >".
      </p>
      <p>
        This action will remove the category from your list, and any
        transactions currently assigned to this category will become
        uncategorized.
      </p>
      <p>
        Would you like to apply a different existing category to all
        transactions that were assigned to the
        {{ store.editCategory.name }} category?
      </p>
      <div class="mb-2">
        <select
          class="mb-1 form-select blue-outline-button form-select-box-shadow"
          v-model="parentCategoryDeleteCategory"
          @change="selectedParentCategoryDeleteCategory"
        >
          <option value="" selected disabled>Category</option>
          <option
            v-for="parentCategory in store.categories"
            :key="parentCategory.categoryID"
            :value="parentCategory"
          >
            {{ parentCategory.name }}
          </option>
        </select>
        <select
          v-if="
            parentCategoryDeleteCategory &&
            parentCategoryDeleteCategory.subcategories
          "
          class="form-select white-form-select form-select-box-shadow mb-1"
          v-model="selectedSubcategoryDeleteCategory"
        >
          <option value="" selected disabled>Subcategory</option>
          <option
            v-for="subcategory in parentCategoryDeleteCategory.subcategories"
            :key="subcategory.categoryID"
            :value="subcategory"
          >
            {{ subcategory.name }}
          </option>
        </select>
      </div>
    </template>
    <template #footer>
      <div class="modal-footer-buttons">
        <button
          @click="closeRecategorizeModal"
          class="button teal-outline-button"
        >
          No, leave transactions uncategorized
        </button>
        <button
          @click="closeRecategorizeModal"
          :disabled="!parentCategoryDeleteCategory"
          class="teal-button"
        >
          Yes, apply the selected category
        </button>
      </div>
    </template>
  </Modal>
  <Modal ref="confirmBudgetEditModal">
    <template #header>
      <h2>Update Default Budget</h2>
    </template>
    <template #body>
      <p>
        You are about to update your default budget for {{ categoryName }} to
        {{ defaultBudget }}.
      </p>
      <div class="mb-2">
        <label>
          <input
            type="checkbox"
            v-model="updateCurrentMonth"
            value="currentMonthUpdate"
          />
          Apply this change to my current months budget
        </label>
      </div>
      <div class="mb-2">
        <label>
          <input
            type="checkbox"
            v-model="updateFutureMonthsWithCustomBudgets"
            value="currentMonthUpdate"
          />
          Also update future months where I manually customized the budget.
        </label>
      </div>
    </template>
    <template #footer>
      <div class="modal-footer-buttons">
        <button
          @click="closeUpdateBudgetModal"
          class="button teal-outline-button"
        >
          Cancel
        </button>
        <button @click="updateCategoryBudget" class="teal-button">
          Update Default Budget
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useMyStore } from '../store';
import { useRouter } from 'vue-router';
import {
  ref,
  reactive,
  watch,
  onUnmounted,
  onBeforeMount,
  onMounted,
} from 'vue';

import MainHeader from '../components/View-Header.vue';
import Slider from '../components/Slider.vue';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import ColorSelection from '../components/Color-Selection.vue';
import Rule from '../components/Categorization-Rule.vue';
import { Edit_Category_Types } from '../utils/constants.js';
import Toggle from '../components/Toggle.vue';
import SkeletonLoader from '../components/SkeletonLoader.vue';
import IconSearch from '../components/Icon-Selector.vue';
import Modal from '../components/Main-Modal.vue';

export default {
  components: {
    MainHeader,
    Slider,
    ColorSelection,
    Rule,
    Toggle,
    SkeletonLoader,
    IconSearch,
    Modal,
  },
  setup() {
    const store = useMyStore();
    const router = useRouter();
    const sliderOptions = [
      { label: 'Info', disabled: false },
      { label: 'Edit', disabled: true },
    ];
    const searchTerm = ref('');
    const searchResults = reactive({});
    let showAutoCategorization = ref(false);
    let showEditSubcategories = ref(false);
    const selectedRule = ref(null);
    let ruleItems = ref([{ id: 1, rule: {} }]);
    let editCategorySliderSelected = ref(false);
    let selectedParentCategory = ref(null);
    const selectedEditParentCategory = ref(
      store.categories.find(
        (x) => x.categoryID === store.editCategory.categoryID
      )
    );
    const categoryName = ref(store.editCategory.name);
    const accountIcon = ref(store.editCategory.icon);
    let selectedCategoryIcon = ref();
    let selectedCategoryIconColor = ref();
    const defaultBudget = ref(store.editCategory.defaultBudget);
    let incomeCategory = ref(store.editCategory.income || false);
    let loading = ref(true);
    let loadingText = ref('Loading...');
    const modalRef = ref(null);
    let parentCategoryDeleteCategory = ref('');
    let selectedSubcategoryDeleteCategory = ref('');
    let updateCurrentMonth = ref(false);
    let updateFutureMonthsWithCustomBudgets = ref(false);
    const confirmBudgetEditModal = ref(null);

    function searchIcons() {
      if (searchTerm.value.length < 3) {
        return;
      }
      const results = findIconDefinition({
        prefix: '',
        iconName: searchTerm.value,
      });
      searchResults.value = results;
    }

    ruleItems = ref(store.categoryRules);

    const createNewRule = () => {
      const newRuleId = ruleItems.value.length + 1;
      ruleItems.value.push({ id: newRuleId, rule: {} });
    };

    const updateRulesList = (index, rule) => {
      ruleItems.value[index].rule = rule;
    };

    const deleteFromRulesList = (index) => {
      ruleItems.value.splice(index, 1);
    };

    const sliderOptionUpdated = (selection) => {
      if (selection === Edit_Category_Types.edit) {
        showAutoCategorization.value =
          store.categoryRules && store.categoryRules.length > 0 ? true : false;
        editCategorySliderSelected.value = true;
      } else {
        editCategorySliderSelected.value = false;
      }
    };

    const parseIconString = (iconString) => {
      if (iconString) {
        const [category, icon] = iconString.split(' ');
        return [category, icon];
      }
      return null;
    };

    const addSubcategory = () => {
      store.updateAddSubcategoryToEditCategory(true);
      let id = selectedEditParentCategory.value.categoryID;
      router.push({ name: 'AddCategory', query: { id } });
    };

    const deleteSubcategory = (subcategory) => {
      const index = store.editCategory.subcategories.indexOf(subcategory);
      if (index !== -1) {
        store.editCategory.subcategories.splice(index, 1);
      }
    };

    const updateSelectedIcon = (selectedIcon) => {
      selectedCategoryIcon.value = selectedIcon;
    };

    const updateSelectedIconColor = (selectedColor) => {
      selectedCategoryIconColor.value = selectedColor;
    };

    const toggleIncome = (event) => {
      incomeCategory.value = event;
    };

    watch(
      () => store.categoryRules,
      (newRules) => {
        ruleItems.value = newRules.map((rule, index) => ({
          id: index + 1,
          rule,
        }));
      }
    );

    const updateCategoryBudget = async () => {
      loadingText.value = 'Updating Category...';
      loading.value = true;

      try {
        let rules;

        if (store.editCategoryIsSubcategory === true) {
          if (
            categoryName.value !== null &&
            categoryName.value.length > 0 &&
            selectedEditParentCategory.value !== null
          ) {
            let newSubCategory = {
              SubcategoryID: store.editCategory.subcategoryID,
              CategoryID: selectedEditParentCategory.value.categoryID,
              Name: categoryName.value,
              Icon: selectedCategoryIcon.value,
              IconColor: selectedCategoryIconColor.value,
              DefaultBudget: defaultBudget.value,
              UpdateCurrentMonthBudget: updateCurrentMonth.value,
              UpdateFutureMonthsWithCustomBudgets:
                updateFutureMonthsWithCustomBudgets.value,
            };

            await store.saveSubcategory(newSubCategory).then(() => {
              loading.value = false;
            });

            rules = {
              CategoryID: store.editCategory.categoryID,
              SubcategoryID: store.editCategory.subcategoryID,
              CategoryRules: ruleItems.value.map((ruleItem) => ({
                Type: ruleItem.rule.type,
                Comparison: ruleItem.rule.comparison,
                ComparisonValue: ruleItem.rule.comparisonValue,
              })),
            };
            await store.saveCategoryRules(rules).then(() => {
              loading.value = false;
              router.push({ name: 'Categories' });
            });
          }
        } else {
          let categoryDetails = {
            CategoryID: store.editCategory.categoryID,
            Name: categoryName.value,
            Icon: selectedCategoryIcon.value.toString(),
            IconColor: selectedCategoryIconColor.value.toString(),
            DefaultBudget: defaultBudget.value,
            Subcategories: store.editCategory.subcategories
              ? store.editCategory.subcategories
              : [],
            Rules: ruleItems.value,
            Income: incomeCategory.value,
            UpdateCurrentMonthBudget: updateCurrentMonth.value,
            UpdateFutureMonthsWithCustomBudgets:
              updateFutureMonthsWithCustomBudgets.value,
          };

          rules = {
            CategoryID: store.editCategory.categoryID,
            SubcategoryID: null,
            CategoryRules: ruleItems.value.map((ruleItem) => ({
              Type: ruleItem.rule.type,
              Comparison: ruleItem.rule.comparison,
              ComparisonValue: ruleItem.rule.comparisonValue,
            })),
          };

          await store.saveCategory(categoryDetails);
          await store.saveCategoryRules(rules).then(() => {
            loading.value = false;
            router.push({ name: 'Categories' });
          });
        }
      } catch (error) {
        loading.value = false;
        console.error('An error occurred:', error);
      }
    };

    const updateCategory = async () => {
      if (defaultBudget.value !== store.editCategory.defaultBudget) {
        confirmBudgetEditModal.value?.openModal();
      } else {
        updateCategoryBudget();
      }
    };

    const deleteCategoryWarning = () => {
      modalRef.value?.openModal();
    };

    const deleteCategory = async () => {
      loadingText.value = 'Deleting Category...';
      loading.value = true;
      try {
        if (
          !Object.prototype.hasOwnProperty.call(
            store.editCategory,
            'subcategoryID'
          )
        ) {
          let categoryDetails = {
            CategoryID: store.editCategory.categoryID,
            Name: store.editCategory.name,
            Subcategories:
              store.editCategory.subcategories === null
                ? []
                : store.editCategory.subcategories,
            Rules: ruleItems.value,
            NewCategoryID: parentCategoryDeleteCategory.value
              ? parentCategoryDeleteCategory.value.categoryID
              : null,
            newSubCategoryID: selectedSubcategoryDeleteCategory.value
              ? selectedSubcategoryDeleteCategory.value.subcategoryID
              : null,
          };
          await store.deleteCategory(categoryDetails).then(() => {
            loading.value = false;
            router.push({ name: 'Categories' });
          });
        } else {
          let subcategoryDetails = {
            SubcategoryID: store.editCategory.subcategoryID,
            CategoryID: store.editCategory.categoryID,
            Name: store.editCategory.name,
            Subcategories:
              store.editCategory.subcategories === null
                ? []
                : store.editCategory.subcategories,
            Rules: ruleItems.value,
            NewCategoryID: parentCategoryDeleteCategory.value
              ? parentCategoryDeleteCategory.value.categoryID
              : null,
            newSubCategoryID: selectedSubcategoryDeleteCategory.value
              ? selectedSubcategoryDeleteCategory.value.subcategoryID
              : null,
          };
          await store.deleteSubcategory(subcategoryDetails).then(() => {
            loading.value = false;
            router.push({ name: 'Categories' });
          });
        }
        store.getAllCategories();
        router.push({ name: 'Categories' });
      } catch (error) {
        loading.value = false;
        console.error('An error occurred:', error);
      }
    };

    const closeUpdateBudgetModal = () => {
      confirmBudgetEditModal.value?.closeModal();
    };

    const closeRecategorizeModal = () => {
      modalRef.value?.closeModal();
      deleteCategory();
    };

    const selectedParentCategoryDeleteCategory = () => {
      selectedSubcategoryDeleteCategory.value = null;
    };

    onBeforeMount(() => {
      if (
        Object.prototype.hasOwnProperty.call(
          store.editCategory,
          'subcategoryID'
        )
      ) {
        selectedParentCategory.value = store.categories.find(
          (category) => category.categoryID === store.editCategory.categoryID
        );
      }
    });

    onMounted(async () => {
      loading.value = true;

      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) {
          mainElement.scrollTo(0, 0);
        }
      }, 100);

      if (!store.editCategory || Object.keys(store.editCategory).length === 0) {
        router.push({ name: 'Categories' });
      }

      updateSelectedIcon(store.editCategory.icon);
      updateSelectedIconColor(store.editCategory.iconColor);
      showEditSubcategories.value = store.editCategory.subcategories
        ? store.editCategory.subcategories.length > 0
        : false;
      incomeCategory.value = store.editCategory.income || false;

      ruleItems.value = store.categoryRules
        ? store.categoryRules.map((rule, index) => ({ id: index + 1, rule }))
        : [];

      loading.value = false;
    });

    onUnmounted(() => {
      if (!store.addSubcategoryToEditCategory) {
        store.updateEditCategory({});
      }
    });

    return {
      store,
      router,
      sliderOptions,
      searchIcons,
      searchTerm,
      searchResults,
      showAutoCategorization,
      showEditSubcategories,
      selectedRule,
      createNewRule,
      ruleItems,
      updateRulesList,
      deleteFromRulesList,
      sliderOptionUpdated,
      editCategorySliderSelected,
      addSubcategory,
      updateCategory,
      deleteSubcategory,
      parseIconString,
      deleteCategory,
      selectedParentCategory,
      selectedEditParentCategory,
      categoryName,
      accountIcon,
      updateSelectedIconColor,
      updateSelectedIcon,
      defaultBudget,
      toggleIncome,
      loading,
      loadingText,
      modalRef,
      parentCategoryDeleteCategory,
      selectedParentCategoryDeleteCategory,
      selectedSubcategoryDeleteCategory,
      deleteCategoryWarning,
      incomeCategory,
      updateCurrentMonth,
      updateFutureMonthsWithCustomBudgets,
      confirmBudgetEditModal,
      updateCategoryBudget,
      closeRecategorizeModal,
      closeUpdateBudgetModal,
    };
  },
};
</script>

<style scoped>
.cat-info-card {
  padding: 1em;
  border-radius: 5px;
  box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1);
}

.light-theme .cat-info-card {
  background: #f8f8f8;
}

.dark-theme .cat-info-card {
  background: #212e3e;
  color: white;
}

.subcategorization-card {
  border-radius: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #004751;
}

.light-theme .edit-subcategorization-card {
  background: #f1f1f1;
}

.dark-theme .edit-subcategorization-card {
  background: #171e29;
  color: #d4d2d2;
  border: 1px solid #d4d2d2;
}

.light-theme .subcategorization-card i {
  color: #004751;
}

.dark-theme .subcategorization-card i {
  color: #d4d2d2;
}

.subcategory-list-wrapper {
  width: 100%;
}

.dark-theme .subcategory-list-wrapper {
  color: #d4d2d2;
  background: transparent;
  border: none;
  border-top: 1px solid #212e3e;
}

.edit-subcategory-list-wrapper {
  background: white;
  border: 1px solid #f1f1f1;
  padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
}
.subcategory-item {
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
}

.light-theme .subcategory-item {
  border: 1px solid #f1f1f1;
}

.dark-theme .subcategory-item {
  background: #171e29;
  border: 1px solid #171e29;
}

.dropdown-padding {
  padding: 10px;
}

.category-color {
  height: 17px;
  width: 17px;
  border-radius: 50%;
}

.dark-theme .icon-wrapper:before,
.dark-theme .sub-icon-wrapper:before {
  background: #212e3e;
}

.icon-wrapper svg {
  display: block;
  position: relative;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}

.auto-rules {
  background: #004751;
  border-radius: 5px;
  padding: 10px;
  color: white;
  font-weight: 500;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
}

.info-icon {
  color: #e8f44a;
}

.subcategory-label {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.subcategory-label .icon {
  color: #851e0d;
}

.arrow {
  margin-left: 0.5em;
  transition: transform 0.2s;
}

.arrow.active {
  transform: rotate(-180deg);
}
</style> -->
